import { useState } from 'react';
import { CheckCircleIcon, PhotoIcon } from '@heroicons/react/24/outline';
import { Panel } from '../../../components/panels/Panel';
import { isSecondaryDefect } from '../../../services/live-interface/verallia-interface-service';

export const VeralliaDefaultBlock = ({ defaults = [], currentDefaultIndex = 0, defaultsSignature = '', displayDurationMs = 5000 }) => {
  const [failedPhoto, setFailedPhoto] = useState(null);

  const defaultData = defaults[currentDefaultIndex] ?? null;
  const hasMultipleDefaults = defaults.length > 1;
  const isPhotoUnavailable = !defaultData?.photo || failedPhoto === defaultData.photo;
  const isSecondary = defaultData !== null && isSecondaryDefect(defaultData.type);

  if (defaultData === null) {
    return (
      <Panel noHeader rounded category="tertiary">
        <div className="flex h-full flex-col items-center justify-center gap-6 text-center">
          <div className="flex size-36 items-center justify-center rounded-full bg-green-500/10">
            <CheckCircleIcon className="size-28 text-green-400" />
          </div>
          <div className="text-4xl font-extrabold text-green-400">Ningún defecto detectado</div>
        </div>
      </Panel>
    );
  }

  return (
    <div className="relative h-full min-h-0 overflow-hidden bg-black">
      {isPhotoUnavailable ? (
        <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
          <PhotoIcon className="size-28 text-perception-gray-700" />
          <div className="text-3xl font-semibold text-perception-gray-700">Foto no disponible</div>
        </div>
      ) : (
        <img src={defaultData.photo} alt="Vista previa del defecto" className="absolute inset-0 h-full w-full object-cover" onError={() => setFailedPhoto(defaultData.photo)} />
      )}

      {hasMultipleDefaults && (
        <>
          <div className="absolute bottom-4 right-4 rounded bg-black/60 px-3 py-1.5 text-lg font-bold text-white backdrop-blur-md">
            {currentDefaultIndex + 1} / {defaults.length}
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-2 bg-white/20">
            <div key={`${defaultsSignature}-${currentDefaultIndex}`} className={`h-full ${isSecondary ? 'bg-amber-500' : 'bg-red-500'}`} style={{ animation: `verallia-default-progress ${displayDurationMs}ms linear forwards` }} />
          </div>
        </>
      )}

      <style>{`
        @keyframes verallia-default-progress {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </div>
  );
};